<template>
  <TabGroup :buttons="getButtons()">
    <template v-if="getButtons().length === 2">
      <List v-if="!$route.query.type || $route.query.type === 'chat'" />
      <CallList v-else-if="$route.query.type === 'call'" />
    </template>

    <template v-else>
      <List v-if="getButtons().find(button => button.type === 'chat')" />
      <CallList v-else-if="getButtons().find(button => button.type === 'call')" />
    </template>
  </TabGroup>
</template>

<script>
import TabGroup from '@/components/TabGroup.vue'
import List from './List.vue'
import CallList from '../callCenterOverview/List.vue'

export default {
  components: {
    List,
    CallList,
    TabGroup,
  },
  data() {
    return {
      buttons: [
        {
          type: 'chat',
          label: 'field.chat',
          permission: 'report-conversation-overview',
        },
        {
          type: 'call',
          label: 'breadcrumb.call',
          permission: 'report-call-center-overview',
        },
      ],
    }
  },
  methods: {
    getButtons() {
      return this.buttons.filter(button => this.$can('manage', button.permission))
    },
  },
}
</script>
